import { KeyboardEvent } from 'react';

import { useFormContext } from 'core/states';
import { usePricingStateContext } from 'quotes/components/QuotePartUpsertLine/UpsertLine/CostSection/CostFormFields';
import { ICustomerQuote } from 'quotes/types';

import { PriceFormFields, PriceFormFieldsProvider } from './PriceFormFields';

interface IProps {
  quote: ICustomerQuote;
  isAlternateVersionEnabled: boolean;
  disabledFields?: boolean;
  costFieldName?: string;
  marginFieldName?: string;
  replacementCostFieldName?: string;
  priceBasedOnFieldName?: string;
  onPriceKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onPriceChange?: (price: number) => void;
  onMarginChange?: (margin: number) => void;
}

export const PriceSection = ({
  quote,
  isAlternateVersionEnabled,
  disabledFields: disabledFieldsProp,
  costFieldName = 'standardCost',
  marginFieldName = 'margin',
  replacementCostFieldName = 'replacementStandardCost',
  priceBasedOnFieldName = 'priceBasedOn',
  onPriceKeyDown,
  onPriceChange: externalOnPriceChange,
  onMarginChange,
}: IProps) => {
  const { watch } = useFormContext();

  const {
    priceData,
    priceDecimals,
    onPriceChange: contextOnPriceChange,
    disablePricingFields,
  } = usePricingStateContext();

  const partValue = watch('part');

  const disabledFields = disabledFieldsProp ?? disablePricingFields;
  const onPriceChange = externalOnPriceChange || contextOnPriceChange;

  return (
    <PriceFormFieldsProvider
      quote={quote}
      priceData={priceData}
      priceDecimals={priceDecimals}
      onPriceChange={onPriceChange}
      onPriceKeyDown={onPriceKeyDown}
      onMarginChange={onMarginChange}
      alternateVendorPartNumber={partValue?.alternateVendorPartNumber}
      costFieldName={costFieldName}
      marginFieldName={marginFieldName}
      replacementCostFieldName={replacementCostFieldName}
      priceBasedOnFieldName={priceBasedOnFieldName}
      disabledFields={disabledFields}
    >
      <PriceFormFields isAlternateVersionEnabled={isAlternateVersionEnabled} />
    </PriceFormFieldsProvider>
  );
};
